export default function anonymous(context
) {
var out='';var arr1=context.object.getSixTypes();if(arr1){var type,i1=-1,l1=arr1.length-1;while(i1<l1){type=arr1[i1+=1];out+='<option value="'+( type )+'">'+( type )+'</option>';} } return out;
}